import Vue from 'vue'
import App from './App.vue'
import router from '@/router';

import Toasted from 'vue-toasted';

// moment のlocaleを設定
import 'moment/locale/ja';

// fontawesome
import { FontAwesomeIcon, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'

import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/base16-dark.css'
import 'codemirror/theme/base16-light.css'

import '@/api/interceptor';
import axios from 'axios';
import { getSkills } from '@/api/Skill';

Vue.component('fa-icon', FontAwesomeIcon)
library.add(faUserSecret)

Vue.config.productionTip = false

if (process.env.VUE_APP_DEV !== 'local') {
  axios.defaults.baseURL = process.env.VUE_APP_BASE_URL
}

const toastOptions = {
  position: 'top-center',
  duration: 2400,
  type: 'info',
  className: 'toast-info',
  iconPack: 'fontawesome',
  Icon: 'check-circle',
}

Vue.use(Toasted, toastOptions);

// ブラウザバックを検知
Vue.prototype.$browserBackFlg = false
// history.replaceState(null, '', null)
window.addEventListener('popstate', function() {
  Vue.prototype.$browserBackFlg = true
  window.setTimeout(() => {
    Vue.prototype.$browserBackFlg = false
  }, 500)
})
declare module "vue/types/vue" {
  interface Vue {
    $browserBackFlg: boolean,
    // $payjp: any,
    $fincode: any,
  }
}

// Vue.prototype.$payjp = null;
Vue.prototype.$fincode = null;
declare global {
  interface Window {
    // Payjp: any;
    Fincode: any;
  }
}

new Vue({
  router,
  render: h => h(App),
  data: () => {
    return {
    }
  },
  async created() {
    // スキルマスタ情報取得
    try {
      const res = await getSkills();
      localStorage.setItem('skill', JSON.stringify(res));
    } catch (e) {
      console.log(e);
    }
  },
  destroyed() {
    localStorage.removeItem('skill');
  }
}).$mount('#app')
